import { render, staticRenderFns } from "./ClustersEditPage.vue?vue&type=template&id=509a31f2&scoped=true&"
import script from "./ClustersEditPage.vue?vue&type=script&lang=js&"
export * from "./ClustersEditPage.vue?vue&type=script&lang=js&"
import style0 from "./ClustersEditPage.vue?vue&type=style&index=0&id=509a31f2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "509a31f2",
  null
  
)

export default component.exports